import { Button } from "components/DesignSystem/Button/Button";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import React from "react";

export const CustomerFeedbackButton = ({
  isSubmitted,
  setExpanded,
  hasRating,
  isSubmitting,
}: {
  isSubmitted: boolean;
  setExpanded: (expanded: boolean) => void;
  hasRating: boolean;
  isSubmitting: boolean;
}) => {
  const { isAdmin } = useRoleBasedView();

  if (isSubmitted) {
    return (
      <Button
        type="button"
        size="small"
        block
        onClick={() => setExpanded(false)}
      >
        Close
      </Button>
    );
  }
  return (
    <Button
      type="submit"
      customType="primary"
      size="small"
      block
      disabled={!hasRating || isAdmin}
      isLoading={isSubmitting}
    >
      Submit feedback
    </Button>
  );
};
